module.exports = __webpack_public_path__ + "static/media/jatin-prasada-slick.5ee8ff47.png";